/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 37);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Ajax request class
 */
var EpsilonAjaxRequest = /** @class */ (function () {
    /**
     * Constructor
     * @param {Object} args
     */
    function EpsilonAjaxRequest(args) {
        this.args = args;
    }
    /**
     * Init Request
     */
    EpsilonAjaxRequest.prototype.request = function () {
        var self = this;
        jQuery.ajax({
            type: 'POST',
            data: { action: 'epsilon_framework_ajax_action', args: self.args },
            dataType: 'json',
            url: EpsilonWPUrls.ajaxurl,
            success: function (data) {
                self.result = data;
                jQuery(self).trigger('epsilon-received-success');
            },
            /**
             * Throw errors
             *
             * @param jqXHR
             * @param textStatus
             * @param errorThrown
             */
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
            }
        });
    };
    return EpsilonAjaxRequest;
}());
exports.EpsilonAjaxRequest = EpsilonAjaxRequest;


/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Epsilon Nav Menu Class
 */
var EpsilonNavMenus = /** @class */ (function () {
    /**
     * Constructor
     * @param api
     */
    function EpsilonNavMenus(api) {
        this.api = api;
        this.context = jQuery('#epsilon-section-navigation-menu');
        this.handleEvents();
    }
    EpsilonNavMenus.prototype.handleEvents = function () {
        var _this = this;
        jQuery('#submit-epsilon-section').on('click', function (evt) {
            var self = _this;
            var object = {
                label: _this.context.find('#epsilon-section-label').val(),
                value: _this.context.find('#epsilon-section-id').val()
            };
            evt.preventDefault();
            _this.context.find('.spinner').addClass('is-active');
            _this.api.addItemToMenu({
                '-1': {
                    'menu-item-type': 'custom',
                    'menu-item-extra': 'epsilon-frontpage-section',
                    'menu-item-url': '#' + object.value,
                    'menu-item-section': object.value,
                    'menu-item-title': object.label
                }
            }, self.api.addMenuItemToBottom, self.menuAdded);
        });
    };
    EpsilonNavMenus.prototype.menuAdded = function () {
        var div = jQuery('#epsilon-section-navigation-menu');
        div.find('.spinner').removeClass('is-active');
        div.find('#epsilon-section-navigation-menu #epsilon-section-id').val(0).blur();
        div.find('#epsilon-section-navigation-menu #epsilon-section-label').val('').blur();
    };
    return EpsilonNavMenus;
}());
exports.EpsilonNavMenus = EpsilonNavMenus;


/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var epsilon_ajax_request_1 = __webpack_require__(0);
/**
 * Epsilon Notices Class
 */
var EpsilonNotices = /** @class */ (function () {
    /**
     * Class constructor
     */
    function EpsilonNotices() {
        var self = this;
    }
    /**
     * Initiate notice dismissal
     */
    EpsilonNotices.prototype.init = function () {
        var self = this;
        var notices = jQuery('.epsilon-framework-notice'), id, args, Ajax;
        jQuery.each(notices, function () {
            jQuery(this).on('click', '.notice-dismiss', function () {
                id = jQuery(this).parent().attr('data-unique-id');
                args = {
                    action: ['Epsilon_Notifications', 'dismiss_notice'],
                    nonce: EpsilonWPUrls.ajax_nonce,
                    args: {
                        notice_id: jQuery(this).parent().attr('data-unique-id'),
                        user_id: userSettings.uid,
                    }
                };
                Ajax = new epsilon_ajax_request_1.EpsilonAjaxRequest(args);
                Ajax.request();
            });
        });
    };
    return EpsilonNotices;
}());
exports.EpsilonNotices = EpsilonNotices;


/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var notices_1 = __webpack_require__(11);
var nav_menus_1 = __webpack_require__(10);
jQuery(document).ready(function () {
    var notices = new notices_1.EpsilonNotices();
    notices.init();
    if (typeof wpNavMenu !== 'undefined') {
        new nav_menus_1.EpsilonNavMenus(wpNavMenu);
    }
});


/***/ })

/******/ });


// WEBPACK FOOTER //
// epsilon-framework-admin.js